// Result slider = AB 150's (user 2026-10-19): same arrows (8 in view, 5 per
// click on desktop; a full view on phone), finger drag with whole-card snap,
// 0.75s slide.
import { AB4Carousel } from './AB4Result';

// ANDAR BAHAR 50 CARDS result — col-lg-8 me d-flex: abj-title (ANDAR/BAHAR labels)
// + col-9 me do card-inner (AB4Carousel). Andar = odd indices
// (deal position 2,4,..,50), Bahar = even indices (1,3,..,49). col-lg-4 me Winner.
export default function AB3Result({ detail }) {
  const allCards = (detail?.card || '').split(',').map((c) => c.trim()).filter(Boolean);
  const andar = allCards.filter((_, i) => i % 2 === 1);
  const bahar = allCards.filter((_, i) => i % 2 === 0);
  const andarIdx = andar.map((_, i) => i * 2 + 2);
  const baharIdx = bahar.map((_, i) => i * 2 + 1);
  const winner = detail?.winnat || detail?.rdesc || 'Win';

  return (
    <div className="row row5 ab2-result">
      <div className="col-12 col-lg-8">
        <div className="d-flex">
          <div className="mr-3 abj-title">
            <div className="row row5"><div className="col-12"><b>ANDAR</b></div></div>
            {' '}
            <div className="row row5"><div className="col-12"><b>BAHAR</b></div></div>
          </div>
          {' '}
          <div className="col-9">
            <div className="card-inner">
              <div className="row row5">
                <div className="col-10">
                  {andar.length > 0 && <AB4Carousel cards={andar} indices={andarIdx} />}
                </div>
                {' '}
                <div className="col-2"></div>
              </div>
            </div>
            {' '}
            <div className="card-inner">
              <div className="row row5">
                <div className="col-10">
                  {bahar.length > 0 && <AB4Carousel cards={bahar} indices={baharIdx} />}
                </div>
                {' '}
                <div className="col-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-4">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner <span className="float-right">:</span></div>
            {' '}
            <div>{winner}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
